import { createFileRoute } from '@tanstack/react-router'

import { GuidelinePage } from '@/pages/guideline/Guideline.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId/',
)({
  component: GuidelinePage,
})
